import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, Table, TableBody, TableCell, TableHead, TableRow, Chip, Button, TablePagination } from '@mui/material';
import api from '../../api';

const LeaveUnallocationHistory = ({ empId, showMsg }) => {
  const [unallocations, setUnallocations] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    loadUnallocations();
  }, []);

  const loadUnallocations = async () => {
    try {
      const unallocRes = await api.get('/leave/unallocations');
      setUnallocations(unallocRes.data);
    } catch (err) { console.error(err); }
  };

  const processAction = async (id, action) => {
    try {
      await api.put(`/leave/unallocations/approve/${id}?action=${action}`, { approved_by: empId });
      showMsg(`Unallocation ${action}D successfully!`);
      loadUnallocations();
    } catch (err) { 
      showMsg(err.response?.data?.detail || "Failed", "error"); 
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>Unallocation Report</Typography>
      <Table size="small">
        <TableHead sx={{ bgcolor: '#ffebee' }}>
          <TableRow>
            <TableCell>Leave Emptied</TableCell>
            <TableCell>Reason</TableCell>
            <TableCell>Target</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {unallocations.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(ua => (
            <TableRow key={ua.id}>
              <TableCell sx={{ fontWeight: 'bold', color: 'error.main' }}>{ua.leave_type}</TableCell>
              <TableCell>{ua.reason}</TableCell>
              <TableCell><Chip size="small" label={ua.assignment_type} /></TableCell>
              <TableCell>
                {ua.status === 'PENDING' ? 
                  <Button size="small" color="error" variant="contained" onClick={() => processAction(ua.id, 'APPROVE')}>Approve Empty</Button> : 
                  <Chip size="small" label={ua.status} />
                }
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination 
        component="div" 
        count={unallocations.length} 
        page={page} 
        onPageChange={(e, p) => setPage(p)} 
        rowsPerPage={rowsPerPage} 
        onRowsPerPageChange={e => {setRowsPerPage(parseInt(e.target.value, 10)); setPage(0);}} 
      />
    </Paper>
  );
};

export default LeaveUnallocationHistory;